export const NAVBAR_EVENTS = {
  RUN_CAMPAIGN: 'CMP Login',
  SETTINGS: 'Settings - Account Details',
  CHAMPION_TRACKING: 'Champion Tracking - All Champions',
};
